import React, { useEffect, useState } from 'react';
import AgreementPresentational from './agreementPresentational';
import Selectors from '../selectors';
import { connect } from 'react-redux';
import Actions from '../action';
import { API_DOMAIN, notificationStrings } from '@constants/app-constants';
import axios from 'axios';
import { openNotificationWithIcon } from '@sharedComponent/notification-message/notification';

const AgreementFunctional = ({
	buttonMode,
	buttonName,
	getCompanyAgreementStart,
	isCompAgreementLoading,
	// compAgmnt
}) => {
	useEffect(() => {
		buttonMode?.('triple');
		buttonName?.('Sign Now');
	}, []);

	const [file, setFile] = useState({
		loading: true,
		url: null,
	});
	const [docusignCreateLoading, setDocusignCreateLoading] = useState(null);

	const getEmpFileURL = () => {
		// const access_token = JSON.parse(localStorage.getItem(APP_VARIABLES.ACCESS_TOKEN)).access_token;
		setDocusignCreateLoading(true);
		let companyId = localStorage.getItem('companyId');
		let createRes = axios.post(`${API_DOMAIN}/DocumentSign/${companyId}/Envelope/Create/`);
		createRes.then((res) => {
			if (res.data.company.docuSignEmbeddedSigningReturnUrl) {
				window.location.href = res.data.company.docuSignEmbeddedSigningReturnUrl;
			}
			setDocusignCreateLoading(false);
		}).catch((err) => {
			openNotificationWithIcon(notificationStrings.error, err.message ? err.message : 'Something went wrong');
			setDocusignCreateLoading(false);
		});
	};

	const getEmpPDFURL = () => {
		let companyId = localStorage.getItem('companyId');
		return fetch(`${API_DOMAIN}/DocumentSign/${companyId}/Agreement/Download`, {
			method: 'POST'
		}).then((res) => {
			return res.blob();
		});
	};

	useEffect(() => {
		setFile({
			...file,
			loading: true,
		});
		getEmpPDFURL().then((res) => {
			var objectURL = URL.createObjectURL(res);
			setFile({
				...file,
				loading: false,
				url: objectURL,
			});
		}).catch((err) => {
			setFile({
				...file,
				loading: false,
			});
		});
	}, []);

	const { url, loading } = file;

	return (
		<>
			<AgreementPresentational {...{ url, loading, isCompAgreementLoading, docusignCreateLoading, getEmpFileURL }}></AgreementPresentational>
		</>
	);
};
const mapStateToProps = (state) => {
	return {
		compAgmnt: Selectors.compAgmnt(state),
		isCompAgreementLoading: Selectors.isCompAgreementLoading(state),
	};
};
const mapDispatchToProps = (dispatch) => {
	return {
		getCompanyAgreementStart: () => dispatch(Actions.creators.getCompanyAgreementStart()),
	};
};

const Connected = connect(mapStateToProps, mapDispatchToProps)(AgreementFunctional);
export default Connected;